// Implements: F-IDN-009, F-IDN-026
/**
 * `/invitacion/:token` (Default P3-1): the page a copied invitation link opens. It is public and it
 * sits outside the `401` redirect on purpose: a token the server does not know answers `401`, and
 * that is said on this page ("Esta invitación ya no es válida"), not turned into a trip to `/login`.
 * Once accepted, the person is signed in and lands on the gallery.
 */

import type { ReactElement } from "react";
import { useNavigate, useParams } from "react-router";

import { InvitationAcceptContainer } from "../../modules/organization/containers/InvitationAcceptContainer";
import styles from "./InvitationPage.module.css";

export function InvitationPage(): ReactElement {
  const { token = "" } = useParams();
  const navigate = useNavigate();
  return (
    <main className={styles.page}>
      <div className={styles.card}>
        <InvitationAcceptContainer
          key={token}
          token={token}
          onAccepted={() => {
            void navigate("/", { replace: true });
          }}
        />
      </div>
    </main>
  );
}
